// extracted by mini-css-extract-plugin
export default {"companyItem":"companyItem_companyItem__GfHk8","logo":"companyItem_logo__XX0eB","text":"companyItem_text__z88al"};